import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";

import AdminTable from "../../../../components/common/table/AdminTable";
import AdvancedSearch from "../components/advancedSearch/Filters";
import { TableExportButton } from "../../../../components/common/table/TableExportButton";
import TableOptions from "../../../../components/common/table/TableOptions";
import Filters from "./Filters";
import styles from "./Projects.scss";

import parseAdvancedSearch from "../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../utils/parseFilters";
import {
  encodeSearchParams,
  getFinalQueryString,
  getPageQueryString
} from "../../../../utils/parseQueries";
import parseSortData from "../../../../utils/parseSortData";

const tableColumns = [
  {
    headerText: "COMPANY NAME",
    accessor: "employer",
    sortable: false
  },
  {
    headerText: "PROJECT TITLE",
    accessor: "title",
    sortable: true
  },
  {
    headerText: "STATUS",
    accessor: "status",
    sortable: true
  },
  {
    headerText: "RATE TYPE",
    accessor: "rate_type",
    sortable: true
  },
  {
    headerText: "BUDGET AMOUNT",
    accessor: "budget_amount",
    sortable: true
  },
  {
    headerText: "SELECTED MEMBER",
    accessor: "selected_member",
    sortable: false
  },
  {
    headerText: "DATE SUBMITTED",
    accessor: "date_submitted",
    sortable: true
  },
  {
    headerText: "DATE APPROVED",
    accessor: "date_approved",
    sortable: true
  },
  {
    headerText: "TSS ADMIN",
    accessor: "admin",
    sortable: false
  },
  {
    headerText: "LAST ACTIVITY",
    accessor: "last_activity",
    sortable: true
  }
];

const STATUS_ID_SUBMITTED = 2;
const STATUS_ID_APPROVED = 4;

class Projects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: props.advancedSearch || [],
      filters: props.filters || [],
      currentPage: props.page || 1,
      showAdvancedSearch: false,
      showFilters: false
    };

    this.handleSubmitAdvancedSearch = this.handleSubmitAdvancedSearch.bind(
      this
    );
    this.handleSubmitFilters = this.handleSubmitFilters.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.openAdvancedSearch = this.openAdvancedSearch.bind(this);
    this.openFilters = this.openFilters.bind(this);
  }

  handleSubmitAdvancedSearch(data) {
    const advancedSearch = parseAdvancedSearch(data.filters);
    const filters = parseFilters(this.state.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(finalQueryString);
    this.props.getCsvData(filters + advancedSearch);
    this.props.setPage({ table: "projects", pageNumber: 1 });
    this.props.setSort({ table: "projects", sortData: null });

    this.setState({ advancedSearch: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(data.filters, this.state.filters)
    });
  }

  handleSubmitFilters(data) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(data.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(finalQueryString);
    this.props.getCsvData(filters + advancedSearch);
    this.props.setPage({ table: "projects", pageNumber: 1 });
    this.props.setSort({ table: "projects", sortData: null });

    this.setState({ filters: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(this.state.advancedSearch, data.filters)
    });
  }

  onPageChange(pageIndex) {
    window.scrollTo(0, 0);

    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(this.props.sortData);
    const pageQuery = getPageQueryString(pageIndex);
    const finalQueryString = getFinalQueryString(
      pageQuery + filters + advancedSearch + sort
    );

    this.props.getTable(finalQueryString);
    this.props.setPage({ table: "projects", pageNumber: pageIndex + 1 });

    this.setState({ currentPage: pageIndex + 1 });
  }

  onSortChange(sortData) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(sortData);
    const finalQueryString = getFinalQueryString(
      filters + advancedSearch + sort
    );

    this.props.getTable(finalQueryString);
    this.props.setPage({ table: "projects", pageNumber: 1 });
    this.props.setSort({ table: "projects", sortData });

    this.setState({ currentPage: 1 });
  }

  openAdvancedSearch() {
    this.setState({ showAdvancedSearch: true });
  }

  openFilters() {
    this.setState({ showFilters: true });
  }

  setCompanyName(name) {
    localStorage.setItem("adminCompanyName", name);
  }

  getProjectTitle(project) {
    if (!project) return null;
    return (
      <Link to={`/admin/project/${project.id}/detail`}>{project.title}</Link>
    );
  }

  getCompanyName(company) {
    if (!company) return null;
    return (
      <Link
        to={`/admin/company/${company.id}`}
        onClick={() => this.setCompanyName(company.name)}
      >
        {company.name}
      </Link>
    );
  }

  getAdmin(admin) {
    if (!admin) return <div className={styles.none}>None</div>;
    return `${admin.first_name} ${admin.last_name}`;
  }

  getSelectedMember(hired) {
    if (!hired) return <div className={styles.none}>None</div>;
    return `${hired.member.first_name} ${hired.member.last_name}`;
  }

  getActivity(activity) {
    if (!activity) return <div className={styles.none}>—</div>;
    return moment(activity).format("M/DD/YYYY");
  }

  getDateByStatus(projectStatus, date, status) {
    if (projectStatus !== status) return "";
    return moment(date).format("M/DD/YYYY");
  }

  getDateByStatusSort(projectStatus, date, status) {
    if (projectStatus !== status) return "";
    return date;
  }

  getTableData(target) {
    const projects =
      target === "csv" ? this.props.projects_csv : this.props.projects;

    let data = projects.map(project => {
      let logSubmitted = _.filter(project.log, log => {
        return log.status_id == STATUS_ID_SUBMITTED;
      });
      logSubmitted = logSubmitted.length > 0 ? logSubmitted[0] : {};

      let logApproved = _.filter(project.log, log => {
        return log.status_id == STATUS_ID_APPROVED;
      });
      logApproved = logApproved.length > 0 ? logApproved[0] : {};

      return {
        id: project.id,
        employer: this.getCompanyName(
          _.get(project, "employer.profile.company")
        ),
        title: this.getProjectTitle(project),
        status: _.get(project, "status.display_name"),
        rate_type: project.budget_type && project.budget_type.value,
        budget_amount: project.budget_rate_value,
        selected_member: this.getSelectedMember(project.hired[0]),
        date_submitted: this.getDateByStatus(
          logSubmitted.status_id,
          logSubmitted.modified_at,
          STATUS_ID_SUBMITTED
        ),
        date_approved: this.getDateByStatus(
          logApproved.status_id,
          logApproved.modified_at,
          STATUS_ID_APPROVED
        ),
        admin: this.getAdmin(project.admin),
        last_activity: this.getActivity(project.last_activity_at),
        // For filters:
        status_id: _.get(project, "status.id"),
        city: project.city,
        budget_type: project.budget_type && project.budget_type.id,
        overview: project.overview || "",
        responsibilities: project.responsibilities || "",
        // For sorting:
        last_activity_sort: project.last_activity_at,
        date_submitted_sort: this.getDateByStatusSort(
          _.get(project, "status.id"),
          project.status_updated_at,
          STATUS_ID_SUBMITTED
        )
      };
    });

    return data;
  }

  render() {
    return (
      <div>
        <AdvancedSearch
          show={this.state.showAdvancedSearch}
          onClose={() => this.setState({ showAdvancedSearch: false })}
          onSubmit={this.handleSubmitAdvancedSearch}
        />
        <Filters
          show={this.state.showFilters}
          onClose={() => this.setState({ showFilters: false })}
          onSubmit={this.handleSubmitFilters}
        />
        <TableOptions
          title="Projects / All"
          paginationCount={this.props.paginationCount}
          onFilterClick={this.openFilters}
          filtersNumber={this.state.filters && this.state.filters.length}
          searchsNumber={
            this.state.advancedSearch && this.state.advancedSearch.length
          }
          tableColumns={tableColumns}
          onSearchClick={this.openAdvancedSearch}
        />
        <div className={styles.projects}>
          <AdminTable
            page={this.state.currentPage - 1}
            tableData={this.getTableData()}
            tableColumns={tableColumns}
            loading={this.props.loading}
            noRowsText="No projects found"
            numberOfPages={this.props.numberOfPages}
            onPageChange={this.onPageChange}
            sortData={this.props.sortData}
            onSortChange={this.onSortChange}
            style={{
              height: "640px" // This will force the table body to overflow and scroll
            }}
          />
        </div>
        <Col
          lg={2}
          md={2}
          sm={2}
          style={{ textAlign: "center", paddingTop: "1.5em" }}
        >
          <TableExportButton
            tableColumns={tableColumns}
            tableData={this.getTableData("csv")}
          />
        </Col>
      </div>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/routes/admin/projects/components/Projects.js